import { Skeleton } from "@/components/ui";

// Mirrors ProductPage's frame, gutters and grid so the loaded page doesn't shift (DESIGN.md §7).
// Kept literal (not imported from ProductPage) to avoid a circular import between the two modules.
export function ProductPageSkeleton() {
  return (
    <>
      {/* Reserves the marketplace utility header's 64px (shown from xl) without a search input that can't act yet. */}
      <div aria-hidden="true" className="hidden h-16 xl:block" />
      <main className="px-6 py-6 lg:px-8">
        <div className="mx-auto max-w-(--breakpoint-2xl) space-y-6">
          <Skeleton className="h-8 w-96 max-w-full" />
          <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_320px] xl:grid-cols-[minmax(0,1fr)_384px]">
            <div className="min-w-0 space-y-3">
              <Skeleton className="aspect-16/10 w-full rounded-lg" />
              <div className="flex gap-2 overflow-hidden">
                {Array.from({ length: 3 }, (_, index) => (
                  <Skeleton key={index} className="aspect-16/10 w-32 shrink-0 rounded-sm" />
                ))}
              </div>
              {/* Tab rail (Overview/Files & Specs/Reviews/…) plus a little content, so the loaded
                  tabbed layout doesn't shift the page. */}
              <Skeleton className="h-10 w-full max-w-md rounded-sm" />
              <Skeleton className="h-40 w-full rounded-md" />
            </div>
            <div className="space-y-4">
              <Skeleton className="h-160 w-full rounded-md" />
              <Skeleton className="h-48 w-full rounded-md" />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
